import { render, staticRenderFns } from "./PromoterLinkModal.vue?vue&type=template&id=15f9fff0&scoped=true&"
import script from "./PromoterLinkModal.vue?vue&type=script&lang=js&"
export * from "./PromoterLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./PromoterLinkModal.vue?vue&type=style&index=0&id=15f9fff0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f9fff0",
  null
  
)

export default component.exports